import { proxyCustomElement, HTMLElement } from '@stencil/core/internal/client';

const rocheMagnetCss = ":host{display:block;margin-top:3rem;margin:-3rem 0}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}@media (min-width: 64rem){:host{margin:-5rem 0}}";
const RocheMagnetStyle0 = rocheMagnetCss;

const RocheMagnet$1 = /*@__PURE__*/ proxyCustomElement(class RocheMagnet extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    static get style() { return RocheMagnetStyle0; }
}, [1, "roche-magnet"]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-magnet"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-magnet":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheMagnet$1);
            }
            break;
    } });
}

const RocheMagnet = RocheMagnet$1;
const defineCustomElement = defineCustomElement$1;

export { RocheMagnet, defineCustomElement };

//# sourceMappingURL=roche-magnet.js.map